export const HERO_WRAPPER_BASE =
  "relative -mx-4 md:-mx-8 w-[calc(100%+2rem)] md:w-[calc(100%+4rem)] min-h-[58dvh] md:min-h-[70dvh] mb-0 overflow-hidden mask-[linear-gradient(to_bottom,black_68%,transparent_100%)]";
